export const loadLocalStoreData = (name: string, defaultValue = null, serialization = false) => {
  try {
    const serializedData = localStorage.getItem(name);

    if (serializedData === null) {
      return defaultValue;
    }
    return serialization ? JSON.parse(serializedData) : serializedData;
  } catch (error) {
    return defaultValue;
  }
};

export const saveLocalStoreData = (key: string, data: any, serialization = false) => {
  try {
    const serializedData = serialization ? JSON.stringify(data) : data;

    localStorage.setItem(key, serializedData);
  } catch (error) {
    //eslint-disable-next-line
    console.log(error, "Privacy browser issue");
  }
};
